<div class="top-btns" [class.top-btns__minimized]="!opened">
  <button
    mat-fab
    [class.sidenav-button-menu]="!opened"
    [class.sidenav-button-close]="opened"
    (click)="toggle()"
    >
    <mat-icon>{{ !opened ? 'menu' : 'close' }}</mat-icon>
  </button>
</div>

<div class="logo-container" [ngClass]="opened ? 'full' : 'small'">
  <img alt="Shell-logo" src="/assets/images/shell.png" class="sidenav-logo" />

  @if (opened) {
    <img
      alt="Halliburton-logo"
      src="../../../assets/images/Halliburton-Logo.png"
      class="sidenav-logo"
      />
    } @else {
      <img alt="H-logo" src="../../../assets/images/Halli_H-Logo.png" class="sidenav-logo" />
    }

    <img alt="ANP-logo" src="../../../assets/images/ANP-Logo.png" class="sidenav-logo" />
  </div>

  <mat-divider class="sidenav-divider"></mat-divider>

  <a
    mat-button
    class="sidenav-button"
    [class.minimized]="!opened"
    [routerLink]="'/dashboard'"
    routerLinkActive="active"
    id="dashboard-btn"
    >
    <mat-icon class="sidenav-icon">dashboard</mat-icon>
    @if (notificationsCount) {
      <div class="notifications-counter">
        <div class="circle">
          <span class="counter">{{ notificationsCount }}</span>
        </div>
      </div>
    }
    @if (opened) {
      <span class="sidenav-span">Simulations in progress</span>
    }
  </a>

  <a
    mat-button
    class="sidenav-button"
    [class.minimized]="!opened"
    [routerLink]="'/simulations-search'"
    routerLinkActive="active"
    id="simulator-btn"
    >
    <mat-icon class="sidenav-icon">search</mat-icon>
    @if (opened) {
      <span class="sidenav-span">Simulations search</span>
    }
  </a>

  @if (opened) {
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" routerLinkActive="active-parent">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="sidenav-icon">schema</mat-icon>
            <span class="accordion-title">Subsample</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <a
          mat-button
          class="sidenav-button sidenav-button-nested"
          [routerLink]="'/rock-images'"
          routerLinkActive="active"
          id="rock-images-btn"
          >
          <mat-icon class="sidenav-icon">gradient</mat-icon>
          <span class="sidenav-span">Segmented Rock Images</span>
        </a>
        <mat-expansion-panel [expanded]="true" class="inner-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">computer</mat-icon>
              <span class="sidenav-span">Simulations</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/pore-throat-size-distributions'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Pore Throat Size Distribution</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/absolute-permeability'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Absolute Permeability</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/formation-factor'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Formation Factor</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/cube-trend/absolute-permeability'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Cube Trend - Absolute Permeability</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/cube-trend/formation-factor'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Cube Trend - Formation Factor</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/capillary-pressure'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Capillary Pressure</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/relative-permeability'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Relative Permeability</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/saturation-exponent'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Saturation Exponent</span>
          </a>
        </mat-expansion-panel>
      </mat-expansion-panel>
    </mat-accordion>
  }

  @if (opened) {
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" routerLinkActive="active-parent">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="sidenav-icon">schema</mat-icon>
            <span class="accordion-title">Upscaling</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <a
          mat-button
          class="sidenav-button sidenav-button-nested"
          [routerLink]="'upscaling/rock-images'"
          routerLinkActive="active"
          id="upscaling-rock-images-btn"
          >
          <mat-icon class="sidenav-icon">gradient</mat-icon>
          <span class="sidenav-span">Upscaling Rock Model</span>
        </a>
        <a
          mat-button
          class="sidenav-button sidenav-button-nested"
          [routerLink]="'/upscaling/fluid-flow-models'"
          routerLinkActive="active"
          >
          <mat-icon class="sidenav-icon">water</mat-icon>
          <span class="sidenav-span">Upscaling Fluid Flow Model</span>
        </a>
        <mat-expansion-panel [expanded]="true" class="inner-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="sidenav-icon">computer</mat-icon>
              <span class="sidenav-span">Simulations</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/upscaling/absolute-permeability'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Absolute Permeability</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/upscaling/formation-factor'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Formation Factor</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/upscaling/capillary-pressure'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Capillary Pressure</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/upscaling/relative-permeability'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Relative Permeability</span>
          </a>
          <a
            mat-button
            class="sidenav-button sidenav-button-nested"
            [routerLink]="'/upscaling/saturation-exponent'"
            routerLinkActive="active"
            >
            <span class="sidenav-span">Saturation Exponent</span>
          </a>
        </mat-expansion-panel>
      </mat-expansion-panel>
    </mat-accordion>
  }

  <span class="sidenav-spacer"></span>

  @if (opened) {
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="sidenav-icon">download</mat-icon>
            <span class="accordion-title">Downloads</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <button
          mat-button
          class="sidenav-button sidenav-button-nested"
          id="user-guide-btn"
          (click)="openUserGuide()"
          >
          <mat-icon class="sidenav-icon">menu_book</mat-icon>
          <span class="sidenav-span">User Guide</span>
        </button>
        <button
          mat-button
          class="sidenav-button sidenav-button-nested"
          id="adr1-phase-segmentation-btn"
          (click)="confirmAndDownload()"
          >
          <mat-icon class="sidenav-icon">blur_on</mat-icon>
          <span class="sidenav-span">Porous Phase Segmentation Tool</span>
        </button>
        <button
          mat-button
          class="sidenav-button sidenav-button-nested"
          id="covered-porosity-template-btn"
          (click)="confirmAndDownloadCoveredPorosityTemplate()"
          >
          <mat-icon class="sidenav-icon">table_view</mat-icon>
          <span class="sidenav-span">Covered Porosity Template</span>
        </button>
      </mat-expansion-panel>
    </mat-accordion>
  }

  <button mat-button class="sidenav-button" [class.minimized]="!opened" id="user-email-btn">
    <mat-icon class="sidenav-icon">account_box</mat-icon>
    @if (opened) {
      <span class="sidenav-span">{{ userEmail }}</span>
    }
  </button>

  <button mat-button class="sidenav-button" [class.minimized]="!opened" (click)="logout()">
    <mat-icon class="sidenav-icon">logout</mat-icon>
    @if (opened) {
      <span class="sidenav-span">Log out</span>
    }
  </button>
